'use strict';

(function () {
  'use strict';

  angular.module('msPublicActivities').controller('PublicContentCtrl', PublicContentCtrl);

  PublicContentCtrl.$inject = ['$log', '$state', '$stateParams', 'providerSvc', 'domainSvc', 'eventTrackingSvc', 'msAuth'];

  /* @ngInject */
  function PublicContentCtrl($log, $state, $stateParams, providerSvc, domainSvc, eventTrackingSvc, msAuth) {
    var vm = this;
    vm.title = 'PublicContentCtrl';
    activate();

    ////////////////

    function activate() {
      $log.debug('PublicContentCtrl ctrl activate');
      buildUrls();
      if ($stateParams.o) {
        var provider = {
          organization: $stateParams.o,
          accessCode: $stateParams.pc,
          group: $stateParams.g,
          referralToken: $stateParams.ref
        };
        providerSvc.setProvider(provider).then(function (resp) {
          if (resp.data === false) {
            $log.debug('Invalid Provider ' + JSON.stringify(provider));
            $state.go('error', {
              message: 'Page not found',
              errorCode: 404
            });
          } else {
            var resolvedProvider = providerSvc.getProvider();
            if (resolvedProvider && resolvedProvider.organization) {
              vm.headerText = resolvedProvider.organization.name;
            }
          }
        });
      }

      if ($stateParams.t && msAuth.getPermissions().length === 0) {
        msAuth.setToken($stateParams.t);
        msAuth.partialLogout();
        eventTrackingSvc.fireEvent('engagement', 'unauthenticatedVisit', 'publicActivity');
      }
    }

    function buildUrls() {
      var base = domainSvc.getBaseDomain();
      vm.loginUrl = $stateParams.loginUrl ? $stateParams.loginUrl : base + '/login';
      vm.signUpUrl = base + '/signup';
      if ($stateParams.o) {
        vm.signUpUrl = vm.signUpUrl + '/' + $stateParams.o;
        //only inject a group if there was an org
        if ($stateParams.g) {
          vm.signUpUrl = vm.signUpUrl + '/' + $stateParams.g;
        }
      }
      if ($stateParams.pc) {
        vm.signUpUrl = vm.signUpUrl + '?pc=' + $stateParams.pc;
      }
      if ($stateParams.ref) {
        var delim = $stateParams.pc ? '&' : '?';
        vm.signUpUrl = '' + vm.signUpUrl + delim + 'ref=' + $stateParams.ref;
      }
      if ($stateParams.signupurl) {
        vm.signUpUrl = $stateParams.signupurl;
      }
    }
  }
})();